// ─── A3 Assurance — 50 Recommended Key Performance Indicators ────────────────
// Copyright (C) 2000 A3 Assurance
// 5 sequences × 10 QCIs = 50 total
// These are defect-prevention inspection checks. On the Kiosk, ticking an item
// FLAGS that defect as found (0 ticked = Clear, some = Attention, all = HOLD).
// W-20: the server keeps its own copy of these lists and checks Complete
// against it. After changing a list here, regenerate the server copy
// (sfm-web-backend: node tools/gen-qci-checklists.mjs <this repo>) and deploy.
//
// Station key names must match entries in the STATIONS array in KioskView.jsx.

const KPI_CHECKLISTS = {

  // ── 1. VENDOR CONTROL ─────────────────────────────────────────────────────
  "Vendor Control": [
    "Late Deliveries",
    "NO CMTR's or CofC's",
    "Damaged Material",
    "Defective Material",
    "NO Material ID",
    "Wrong Material Grade",
    "NO P.O number on Material",
    "Wrong Heat Number on Material",
    "MISC. Errors",
    "Foreign Material Delivered",
  ],

  // ── 2. DETAILING (flagged during Cut stage) ────────────────────────────────
  "Cut": [
    "Missed Dimensions",
    "Wrong Dimensions",
    "No Weld Symbols",
    "Wrong Weld Symbols",
    "Insufficient Information",
    "Wrong Material Grade",
    "Interference of Parts",
    "Missing Parts",
    "MISC. Errors",
    "Drawings Not Checked",
  ],

  // ── 3. FITTING ────────────────────────────────────────────────────────────
  "Fit": [
    "Wrong Material",
    "Wrong Dimensions",
    "Mis-located Holes",
    "Wrong size holes",
    "Wrong Detail on Drawing",
    "Material Detailed to Long",
    "Material Detailed to Short",
    "Bad Cope",
    "Cope on Wrong Side",
    "MISC.",
  ],

  // ── 4. WELDING ────────────────────────────────────────────────────────────
  "Weld": [
    "Weld Cracks",
    "Incomplete Penetration",
    "Lack of Fusion",
    "Lack of Penetration",
    "Over Sized Welds",
    "Weld Porosity",
    "Weld Undercut",
    "Overlap",
    "Missing Weld",
    "Wrong Consumables / Process",
  ],

  // ── 5. PAINTING ───────────────────────────────────────────────────────────
  "Paint": [
    "Wrong Colour",
    "Mud Cracking",
    "Orange Peel",
    "Lack of Adhesion",
    "Runs and Sags",
    "Incorrect DFT",
    "Incorrect Blast Profile",
    "Contamination",
    "Blistering",
    "Dry Over Spray",
  ],
};

export default KPI_CHECKLISTS;
